/*jshint esversion: 6 */

import WidgetShortList from "../widgets/WidgetShortList";
import GenericSearch from '../forms/search/GenericSearch.js';
import CategorySearch from '../forms/search/CategorySearch.js';
import WidgetVideoView from "../widgets/WidgetVideoView";
import WidgetVideoCarouselPreload from "../widgets/WidgetVideoCarouselPreload";

GenericSearch();
CategorySearch({
    locale: LOCALE,
    env: ENV,
});


WidgetVideoView({
    selector: 'video-views',
    locale: LOCALE,
    env: ENV,
    route: "/widget/video/%id%/views"
});

WidgetVideoCarouselPreload({
    route: '/widget/carousel/video/featured/page/%pageNo%/%limit%',
    locale: LOCALE,
    env: ENV,
    type: 'video_featured',
    maxImages: IMAGE_CAROUSEL_MAX_IMAGES,
    displayInterval: IMAGE_CAROUSEL_DISPLAY_INTERVAL,
    dataRefreshInterval: IMAGE_CAROUSEL_DATA_REFRESH_INTERVAL,
    preferredImageSize: 'xlarge'
});
